export default "__VITE_PUBLIC_ASSET__3303015e__"